// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiCodeTags, mdiCounter, mdiGreaterThan, mdiLessThan, mdiSigma } from "@mdi/js";
import { MenuProps } from "antd";
import { CalculationMethod } from "constants/charts.enums";

import { EntityKind } from "models/entityKind";

export const createStackedBarCalculationItems = (
  entityKind: EntityKind
): MenuProps["items"] => [
  {
    key: CalculationMethod.Count,
    label: entityKind === EntityKind.Well ? "Well Count" : "Facility Count",
    icon: <Icon path={mdiCounter} size={1} />
  },
  {
    key: CalculationMethod.Sum,
    label: "Sum",
    icon: <Icon path={mdiSigma} size={1} />
  },
  {
    key: CalculationMethod.Average,
    label: "Average",
    icon: <Icon path={mdiCodeTags} size={1} />
  },
  {
    key: CalculationMethod.Min,
    label: "Min",
    icon: <Icon path={mdiLessThan} size={1} />
  },
  {
    key: CalculationMethod.Max,
    label: "Max",
    icon: <Icon path={mdiGreaterThan} size={1} />
  }
];
